// src/components/CommonCard.jsx
import React from "react";
import { Card, Box } from "@mui/material";

const CustomCard = ({ children, sx }) => {
  return (
    <Card
      sx={{
        padding: 3,
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
        ...sx, 
      }}
    >
      <Box>{children}</Box>
    </Card>
  );
};

export default CustomCard;
